import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { Package } from "../logic/api";
import { SessionContext } from "../utility/useSession";

interface UsePackageOptions {
    packageCode: string | null;
    packageRef: string | null;
    carParkId?: number;
    enabled?: boolean;
}

export const usePackage = ({ packageCode, packageRef, carParkId, enabled = true }: UsePackageOptions) => {
    const { current: session } = useContext(SessionContext);
    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useQuery<Package | null, Error>({
        queryKey: ["package", userUuid, tenantId, carParkId, packageCode, packageRef],
        queryFn: async () => {
            if (!session?.context) {
                throw new Error("Session context not available");
            }
            const response = await fetch(`${session.context.url}/packages/getPackageByCodeOrRef/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...session.context.headers,
                },
                body: JSON.stringify({
                    code: packageCode ?? "",
                    ref: packageRef ?? "",
                    ...(carParkId != null && { carParkId }),
                }),
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch package: ${response.statusText}`);
            }
            return response.json();
        },
        enabled: !!userUuid && !!tenantId && !!session?.context && !!(packageCode || packageRef) && enabled,
        staleTime: 5 * 60 * 1000,
    });
};
